export const blogExcerptLength = () => {
  const blogExcerpt = document.querySelectorAll(
    '.dp-dfg-content.entry-summary',
  );

  if (blogExcerpt.length > 0 && window.location.href.includes('blog')) {
    for (let i = 0; i < blogExcerpt.length; i++) {
      const el = blogExcerpt[i];
      const text = el.textContent.trim();
      if (text.length > 1) {
        el.textContent = text.slice(0, 500);
      }
    }
  }
};
